(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const videos = document.querySelectorAll('[data-heading-media-video]');
  if (!videos.length) return;

  function syncPlayback() {
    videos.forEach((el) => {
      el.setAttribute('playsinline', '');

      if (reduceMotion.matches) {
        el.pause();
        return;
      }

      if (el.dataset.autoplay !== 'true') return;

      el.muted = true;
      const playPromise = el.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    });
  }

  syncPlayback();

  if (typeof reduceMotion.addEventListener === 'function') {
    reduceMotion.addEventListener('change', syncPlayback);
  } else if (typeof reduceMotion.addListener === 'function') {
    reduceMotion.addListener(syncPlayback);
  }
})();
